import { Component, ChangeDetectionStrategy, OnDestroy, OnInit } from '@angular/core';
import { DataService } from './services/data/data.service';
import * as CryptoJS from 'crypto-js';
import { FontResizeService } from './services/font-resize/font-resize.service';
import { ThemeService } from './services/theme-service/theme.service';
import { BlockEmojiService } from './services/block-emoji/block-emoji.service';
import { SessionSyncService } from './services/session-sync/session-sync.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'BOT';

  decryptedData: any;

  constructor(
    private dataService: DataService,
    private fontService: FontResizeService,
    private themeService: ThemeService,
    private blockEmojiService: BlockEmojiService,
    private sessionSyncService: SessionSyncService
  ) {}

  ngOnInit(): void {
    this.blockEmojiService.start();
    this.sessionSyncService.start();
    this.themeService.loadTheme();
    this.dataService.getEncryptedData().subscribe((response: any) => {
      const encryptedText = response.iv;
       
      const secretKey =  response.secretKey; // This should be stored securely
  
      // // Use the CryptoUtil to decrypt the data
      this.decryptedData = CryptoJS.enc.Utf8.parse(encryptedText);
    });
     
  }

  ngOnDestroy(): void {
    this.blockEmojiService.stop();
    this.sessionSyncService.stop();
  }

  setTheme(theme: string) {
    this.themeService.setTheme(theme);
  }

 
}
 // angular.json  // "node_modules/ngx-sharebuttons/themes/modern.scss",
              // "node_modules/ngx-sharebuttons/themes/material.scss"
                           // "node_modules/ngx-owl-carousel-o/lib/styles/prebuilt-themes/owl.carousel.min.css",
              // "node_modules/ngx-owl-carousel-o/lib/styles/prebuilt-themes/owl.theme.default.min.css",